import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import CurrencyFormat from "../../utils/currencyFormat";
import { StyledPopup, HeadModal, SelectStyles } from "./styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { CustomIcon } from "../CustomIcon";
import {
	handleLoadDepartaments,
	handleLoadCities,
	handleToggleShippingModal,
	handleRequestQuote,
	handleOnchangeDefaultCity,
	handleLoadProviders,
	handleResetQuote,
	handleLoadErrorQuote,
} from "../../redux/actions";
import { useStyles } from "./styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import MainButton from "../MainButton";
import { Close } from "../MainModal/Close";
import Spinner from "../Spinner";
import {
	formatDate,
	formatErrorQuote,
	formatNameCity,
} from "../../utils/formatData";
import { language } from "../../utils/language";

export const ShippingModal = (props: any) => {
	const [openSelect, setOpenSelect] = React.useState(false);
	const [openSelect2, setOpenSelect2] = React.useState(false);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const [cities, setCities] = useState(elogisticaState.selectedCity.codigoDane);
	const [resultProviders, setResultProviders] = useState([]);
	const [prov, setProv] = useState(elogisticaState.selectedCity.departamento);
	const [trans, setTrans] = useState("");
	const [alert, setAlert] = useState(false);
	const [menssageError, setMenssageError] = useState("");
	const [responseQuote, setResponseQuote] = useState(false);

	const dispatch = useDispatch();

	const classes = useStyles(props);

	const [check, setCheck] = useState(true);

	const onCloseModal = () => {
		dispatch(handleLoadErrorQuote(""));
		setMenssageError("");
		dispatch(handleToggleShippingModal(false));
		setCheck(false);
		props.refData.current.close();
		setTrans("");
		setAlert(false);
	};

	const handleClose = () => {
		setOpenSelect(false);
	};

	const handleOpen = () => {
		setOpenSelect(true);
		setCheck(false);
		setTrans("");
		dispatch(handleResetQuote());
		dispatch(handleLoadErrorQuote(""));
		setMenssageError("");
	};

	const handleClose2 = () => {
		setOpenSelect2(false);
	};

	const handleOpen2 = () => {
		setOpenSelect2(true);
	};

	const loadSelectedData = () => {
		var onchangeCity = {
			nombre: "",
			departamento: "",
			codigoDane: "",
			trans: "",
		};

		for (let i = 0; i < elogisticaState.cities.length; i++) {
			if (elogisticaState.cities[i].codigo_dane == cities) {
				onchangeCity = {
					nombre: elogisticaState.cities[i].nombre,
					departamento: elogisticaState.cities[i].departamento,
					codigoDane: elogisticaState.cities[i].codigo_dane,
					trans: trans,
				};
			}
		}
		dispatch(handleOnchangeDefaultCity(onchangeCity));
	};

	useEffect(() => {
		loadData();
		loadSelectedData();
	}, [
		elogisticaState.showShippingModal,
		elogisticaState.departaments,
		elogisticaState.cities,
	]);

	const loadData = () => {
		if (elogisticaState.departaments.length === 0) {
			dispatch(handleLoadDepartaments());
		}
		if (elogisticaState.cities.length === 0) {
			dispatch(handleLoadCities());
		}
		if (elogisticaState.providers.length === 0) {
			dispatch(handleLoadProviders());
		}
	};

	useEffect(() => {
		if (
			elogisticaState.selectedCity.codigoDane !== 0 &&
			elogisticaState.selectedCity.codigoDane !== props.codigo &&
			elogisticaState.showShippingModal
		) {
			dispatch(handleResetQuote());
			dispatch(handleLoadErrorQuote(""));
			setMenssageError("");
			setTrans("");
		}
	}, [elogisticaState.selectedCity.codigoDane]);

	useEffect(() => {
		setMenssageError(formatErrorQuote(elogisticaState.errorQuote, homeState.default_language));
	}, [elogisticaState.errorQuote]);

	useEffect(() => {
		setCities(elogisticaState.selectedCity.codigoDane);
		setProv(elogisticaState.selectedCity.departamento);
		if (elogisticaState.requestQuote.length > 0) {
			setTrans(elogisticaState.requestQuote[0].operador);
		}
		setCheck(false);
	}, [elogisticaState.selectedCity.codigoDane]);

	const handleSubmit = () => {
		if (cities != "" && trans != "" && prov != "") {
			loadSelectedData();
			onCloseModal();
			setCheck(true);
			props.setCodigo(elogisticaState.selectedCity.codigoDane);
			setTrans("");
		} else {
			setAlert(true);
		}
	};

	const radioAction = async (e: any) => {
		setResponseQuote(true);
		setAlert(false);

		let parameters = [
			{
				cantidad_unidades: props.quantity,
				peso_real:
					Math.round(props.product.realWeight) === 0
						? 1
						: Math.round(props.product.realWeight),
				alto: props.product.high,
				largo: props.product.long,
				ancho: props.product.width,
			},
		];

		dispatch(handleLoadErrorQuote(""));
		dispatch(handleResetQuote());
		setMenssageError("");
		await requestQuote(parameters, e);
	};

	const requestQuote = async (products: any, operator: string) => {
		if (products.length > 0) {
			const payload = {
				operador: operator,
				id_configuracion: homeState.pickupConfigurationId,
				ciudad_destino: cities,
				valor_mercancia:
					Math.round(props.product.amount) === 0
						? 1
						: Math.round(props.product.amount),
				fecha_cotizacion: formatDate(new Date()),
				envio: products,
			};
			dispatch(handleRequestQuote(payload));
		}
	};

	// providers services
	useEffect(() => {
		var providers = handleReturnOperators();
		setResultProviders(providers);
	}, [elogisticaState.providers, props.product.epaycoDeliveryProviderValues]);

	const handleReturnOperators = () => {
		const productProviders = props.product.epaycoDeliveryProviderValues;
		return elogisticaState.providers
			.filter((item: any) => productProviders.includes(item.operador))
			.map((item2: any) => {
				return {
					operator: item2.operador,
					img: item2.url_logo,
				};
			});
	};

	return (
		<StyledPopup ref={props.refData} modal nested>
			<HeadModal>
				<p className={classes.title}>{language[homeState.default_language]["optionSend"]}</p>
				<Close onClick={() => onCloseModal()} color={homeState.color} />
			</HeadModal>

			<hr className={classes.divider} />
			{elogisticaState.departaments.length === 0 &&
			elogisticaState.cities.length === 0 ? (
				<div className={classes.loadContainer}>
					<Spinner color={homeState.color} />
				</div>
			) : (
				<form onSubmit={handleSubmit}>
					<FormControl sx={{ m: 1, minWidth: 120 }} className={classes.control}>
						<p className={classes.titleInput}>
							{language[homeState.default_language]["labelInputsShiping"]}{" "}
							<span className={classes.required}>*</span>
						</p>
						<SelectStyles
							open={openSelect}
							onClose={handleClose}
							onOpen={handleOpen}
							onChange={(e: any) => setProv(e.target.value)}
							value={prov}
							name="province"
							className={classes.select}
							inputProps={{ "aria-label": "Without label" }}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{elogisticaState.departaments.map((p: any) => (
								<MenuItem value={p}>{formatNameCity(p)}</MenuItem>
							))}
						</SelectStyles>
					</FormControl>
					<FormControl sx={{ m: 1, minWidth: 120 }}>
						<p className={classes.titleInput}>
							{language[homeState.default_language]["city"]}{" "}
							<span className={classes.required}>*</span>
						</p>
						<SelectStyles
							open={openSelect2}
							onClose={handleClose2}
							onOpen={handleOpen2}
							onChange={(e: any) => {
								setCheck(false);
								setTrans("");
								setCities(e.target.value);
							}}
							value={cities}
							name="city"
							className={classes.select}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{elogisticaState.cities.length > 0 &&
								elogisticaState.cities
									.filter(
										(city: any) =>
											city.departamento.toUpperCase() === prov.toUpperCase()
									)
									.map((c: any) => (
										<MenuItem value={c.codigo_dane}>
											{formatNameCity(c.nombre)}
										</MenuItem>
									))}
						</SelectStyles>
					</FormControl>

					<br />
					<Table size="small" aria-label="simple table">
						<TableHead>
							{elogisticaState.errorQuote == "" ? (
								<>
									<TableRow>
										<TableCell
											width="45%"
											style={{ paddingLeft: "12%" }}
											className={classes.tableCell}
										>
											{language[homeState.default_language]["shippingProvider"]}
										</TableCell>
                    <TableCell className={classes.tableCell}>{language[homeState.default_language]["cost"]}</TableCell>
									</TableRow>
								</>
							) : (
								<></>
							)}
						</TableHead>
						{!elogisticaState.LoadError &&
						elogisticaState.requestQuote.length === 0 &&
						elogisticaState.errorQuote === "" &&
						trans != "" ? (
							<>
								<div className={classes.loadCotization}>
									<Spinner color={homeState.color} />
								</div>
							</>
						) : (
							<>
								<TableBody>
									<TableRow className={classes.control}>
										{elogisticaState.errorQuote == "" ? (
											<>
												<TableCell width="40%" style={{ textAlign: "center" }}>
													<RadioGroup
														aria-label="transportadora"
														name="radio-buttons-group"
														onChange={(e: any) => {
															setTrans(e.target.value);
															setCheck(true);
															radioAction(e.target.value);
														}}
														value={
															elogisticaState.requestQuote.length > 0 && check
																? elogisticaState.requestQuote[0].operador
																: trans
														}
													>
														{resultProviders.map((p: any) => (
															<FormControlLabel
																value={p.operator}
																control={<Radio />}
																label={
																	<>
																		<img src={p.img} alt="" width="60px" />
																	</>
																}
															/>
														))}
													</RadioGroup>
												</TableCell>
												<TableCell>
													{elogisticaState.requestQuote.length > 0 ? (
														<>
															{homeState.freeDelivery ? (
                                <span>{language[homeState.default_language]["free"]}</span>
															) : (
																<CurrencyFormat
																	amount={
																		elogisticaState.requestQuote[0].costo_total
																	}
																/>
															)}
														</>
													) : (
														<></>
													)}
												</TableCell>
											</>
										) : elogisticaState.errorQuote != "" ? (
											<>
												<Stack className={classes.warningContent}>
													<Alert
														severity="warning"
														className={classes.warning}
														icon={
															<CustomIcon
																color={""}
																hover={false}
																type="warning"
																size={"26px"}
															/>
														}
													>
														{menssageError}
													</Alert>
												</Stack>
												<br />
											</>
										) : (
											<></>
										)}
									</TableRow>
								</TableBody>
							</>
						)}
					</Table>
					{elogisticaState.errorQuote == "" && alert == false ? (
						<>
							<div className={classes.buttons}>
								<FormControl
									style={{
										marginLeft: "1%",
										marginRight: "10%",
										marginBottom: "8%",
										width: "162.64px",
										height: "35px",
									}}
								>
									<MainButton
										color={homeState.color}
										type="button"
										onClick={() => {
											handleSubmit();
										}}
									>
										{language[homeState.default_language]["save"]}
									</MainButton>
								</FormControl>
								<FormControl
									style={{
										marginLeft: "1%",
										width: "162.64px",
										height: "35px",
									}}
								>
									<MainButton
										color={homeState.color}
										secondary={true}
										type="button"
										onClick={() => {
											onCloseModal();
											dispatch(handleResetQuote());
											dispatch(handleLoadErrorQuote(""));
										}}
									>
										{language[homeState.default_language]["cancel"]}
									</MainButton>
								</FormControl>
							</div>
						</>
					) : (
						<></>
					)}
					{alert ? (
						<>
							<Stack className={classes.warningInfo}>
								<Alert
									severity="warning"
									className={classes.warning}
									icon={
										<CustomIcon
											color={""}
											hover={false}
											type="warning"
											size={"26px"}
										/>
									}
								>
									<p className={classes.textAlert}>
										{language[homeState.default_language]["messageInfoRequered"]}
									</p>
								</Alert>
							</Stack>
						</>
					) : (
						<></>
					)}
				</form>
			)}
		</StyledPopup>
	);
};
